<template>
  <el-dialog
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :destroy-on-close="true"
    :width="dialogWidth"
    :before-close="cancel"
    :title="$t('langcfg.txtColorBarSettings')"
    id="colorbar"
  >
    <el-row class="font-color">
      <el-tabs
        v-if="!isRgp"
        v-model="activeName"
        style="color: white; font-size: 30px"
        :stretch="true"
        :popper-append-to-body="false"
      >
        <el-tab-pane
          v-for="(item, index) in isRgp ? allPropNamesRgp : allPropNames"
          :key="index"
          :label="isRgp ? allPropLblsRgp[index] : allPropLbls[index]"
          :name="item"
        ></el-tab-pane>
      </el-tabs>
      <template v-for="(propName, id) in isRgp ? allPropNamesRgp : allPropNames">
        <settings-template
          v-if="activeName === propName"
          :name="propName"
          :colorBarProps="colorBarProps[propName]"
          :propSettings="propSettings[propName]"
          :mapIndexUI="mapIndexUI"
          :indexInForm="indexInForm"
          :parentForm="parentForm"
          :absRelEnable="absRelEnable"
          :unitEnable="unitEnable"
          :key="id"
          :isRgp="isRgp"
        ></settings-template>
      </template>
    </el-row>
    <el-row slot="footer" class="dialog-footer">
      <el-button type="info" @click="save">
        {{ $t("langcfg.txtSave") }}
      </el-button>
      <el-button type="info" @click="cancel">
        {{ $t("langcfg.txtCancel") }}
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import SettingsTemplate from "./SettingsTemplate";
import { COLOR_BAR_CONFIG } from "../shared/index";
import { TOPOGRAPHYMODES } from "../../shared/consts";
const fs = window.require("fs");

export default {
  name: "ColorBarPropSetting",
  components: {
    SettingsTemplate
  },
  props: {
    show: Boolean,
    propSettings: Object,
    currentType: { type: String, default: "curvature" },
    mapIndexUI: Number,
    shownType: { type: String, default: "normal" },
    parentForm: { type: String, default: "" },
    indexInForm: { type: Number, default: 0 }
  },
  data: function () {
    return {
      isRgp: false,
      allPropNames: ["curvature", "elevation", "heightf", "tfsq"],
      // allPropNames: ['curvature', 'elevation'],
      allPropLbls: [
        this.$t("langcfg.txtCurv"),
        this.$t("langcfg.txtElev"),
        this.$t("langcfg.txtHeightF"),
        this.$t("langcfg.txtTFSQ")
      ],
      allPropNamesRgp: ["rgp"],
      allPropLblsRgp: [this.$t("langcfg.txtRgp")],
      dialogWidth: "700px",
      colorBarProps: JSON.parse(JSON.stringify(COLOR_BAR_CONFIG)),
      activeName: "curvature"
    };
  },
  created() {
    this.isRgp = this.shownType.indexOf(TOPOGRAPHYMODES.contectlens.key) >= 0;
    if (this.isRgp) {
      this.activeName = "rgp";
    }
    if (this.shownType === "compareDiff") {
      for (let item in this.colorBarProps) {
        let obj = this.colorBarProps[item];

        let index = obj.bar.indexOf("AbsNormal");
        if (index >= 0) {
          obj.bar.splice(index, 1);
        }
      }
    }
  },
  methods: {
    save: function () {
      this.$emit("save");
      this.showDialog = false;
    },
    cancel: function () {
      this.$emit("close");
      this.showDialog = false;
    }
  },
  computed: {
    showDialog: {
      get: function () {
        this.activeName = this.currentType;
        return this.show;
      },
      set: function (val) {
        this.$emit("update:show", val);
      }
    },
    absRelEnable() {
      if (
        this.activeName === "curvature" &&
        ((this.parentForm === "fourierAnalysis" &&
          ([1, 3, 4].includes(this.indexInForm) ||
            (this.indexInForm === 0 && this.propSettings["curvature"].style === "style3"))) ||
          (this.parentForm === "fourmaps" &&
            [0, 1, 3].includes(this.indexInForm) &&
            this.propSettings["curvature"].style === "style3") ||
          (this.parentForm === "keratoconus" &&
            this.indexInForm === 0 &&
            this.propSettings["curvature"].style === "style3"))
      ) {
        return false;
      } else {
        return true;
      }
    },
    unitEnable() {
      if (
        this.activeName === "curvature" &&
        this.parentForm === "fourierAnalysis" &&
        (this.indexInForm === 1 || this.indexInForm === 3 || this.indexInForm === 4)
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
#colorbar {
  .el-button {
    border: 1px gray solid;
    min-width: 180px;
    height: 50px;
    margin-left: 5%;
    font-size: @header-fs !important;
  }
}
</style>
<style lang="less">
#colorbar {
  .el-tabs__item {
    font-size: 30px;
    color: white;
    margin-bottom: 5px;
  }
  .el-tabs__nav-wrap.is-scrollable {
    padding: 0 30px;
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    font-size: 30px !important;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/topography/components/ColorBarPropSettings.vue